// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import VideoList from './pages/VideoList';
import WatchVideo from './pages/WatchVideo';
import QuestionComparison from './pages/QuestionComparison';
import QuestionList from './pages/QuestionList';
import { AuthProvider } from './components/AuthContext';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<VideoList />} />
                    <Route path="/watch/:videoId" element={<WatchVideo />} />
                    <Route path="/questions" element={<QuestionList />} />
                    <Route path="/compare" element={<QuestionComparison />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;